import { ConfigStateService, PermissionService } from '@abp/ng.core';
import { UserMenuService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { UserService } from '@proxy/services';
import { eUserMenuItems } from '@volosoft/abp.ng.theme.lepton-x';
import { Subscription } from 'rxjs';
import { LocalStorageConsts } from './shared/AppConsts';
import { AppPermissionConsts } from './shared/consts/app-permission.const';
import { HealthCheckService } from './shared/services/health-check-service';
import { ActivitySyncService } from './shared/synchronization/activity-sync.service';
import { HarvestActivityReportSyncService } from './shared/synchronization/harvest-activity-report-sync.service';
import { MachineSyncService } from './shared/synchronization/machine-sync.service';
import { ProgrammingSyncService } from './shared/synchronization/programming-sync.service';
import { ShiftSyncService } from './shared/synchronization/shift-sync.service';
import { TeamSyncService } from './shared/synchronization/team-sync.service';

@Component({
  standalone: false,
  selector: 'app-root',
  template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout></abp-dynamic-layout>
    <abp-gdpr-cookie-consent></abp-gdpr-cookie-consent>
    <abp-internet-status></abp-internet-status>
  `,
})
export class AppComponent implements OnInit {
  healthCheckSubscription: Subscription;

  constructor(
    private readonly configState: ConfigStateService,
    private readonly userService: UserService,
    private readonly _userMenu: UserMenuService,
    private readonly _healthCheckService: HealthCheckService,
    private readonly _permission: PermissionService,
    private readonly injector: Injector
  ) {
    this._userMenu.removeItem(eUserMenuItems.LinkedAccounts);
    this._userMenu.removeItem(eUserMenuItems.AuthorityDelegation);
    this._userMenu.removeItem(eUserMenuItems.MyAccount);
    this._userMenu.removeItem(eUserMenuItems.SecurityLogs);

    const userState = this.configState.getOne('currentUser');
    if (
      userState &&
      userState.isAuthenticated &&
      userState.email &&
      userState.email != 'admin@abp.io'
    ) {
      this.userService.getByEmailByEmail(userState.email).subscribe();
    }

    this._healthCheckService.setBackendHeartbeatTimeout(LocalStorageConsts.HealthCheckInterval);
    this.healthCheckSubscription = this._healthCheckService.heartBeat$.subscribe();
  }

  ngOnInit() {
    this.injectSynchronizationServicesIfPermitted();
  }

  private injectSynchronizationServicesIfPermitted(): void {
    if (this.hasApprovalPermission()) {
      this.injector.get(TeamSyncService);
      this.injector.get(ShiftSyncService);
      this.injector.get(MachineSyncService);
      this.injector.get(ActivitySyncService);
      this.injector.get(ProgrammingSyncService);
      this.injector.get(HarvestActivityReportSyncService);
    }
  }

  private hasApprovalPermission(): boolean {
    return this._permission.getGrantedPolicy(AppPermissionConsts.Approvals.Default);
  }
}
